// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type OptionsLegacyParser } from '@hey-api/client-axios';
import type { GatewayControllerVersionError, GatewayControllerVersionResponse, AppInfoControllerGetPartnerAppInfoError, AppInfoControllerGetPartnerAppInfoResponse, AuditLogControllerGetAuditLogsData, AuditLogControllerGetAuditLogsError, AuditLogControllerGetAuditLogsResponse, AuthControllerLogoutError, AuthControllerLogoutResponse, AuthControllerUpdateUserLastAccessError, AuthControllerUpdateUserLastAccessResponse, AuthControllerGetUserLastAccessError, AuthControllerGetUserLastAccessResponse, OrganizationManagementControllerCreateAppDefaultPermissionData, OrganizationManagementControllerCreateAppDefaultPermissionError, OrganizationManagementControllerCreateAppDefaultPermissionResponse, OrganizationControllerGetUserOrgListError, OrganizationControllerGetUserOrgListResponse, OrganizationControllerGetAccessibleOrgListError, OrganizationControllerGetAccessibleOrgListResponse, OrganizationControllerGetLastAccessOrgError, OrganizationControllerGetLastAccessOrgResponse, OrganizationControllerUpdateOrgData, OrganizationControllerUpdateOrgError, OrganizationControllerUpdateOrgResponse, RoleControllerCreateCustomRoleData, RoleControllerCreateCustomRoleError, RoleControllerCreateCustomRoleResponse, RoleControllerGetRolesData, RoleControllerGetRolesError, RoleControllerGetRolesResponse, RoleControllerDeleteCustomRolesData, RoleControllerDeleteCustomRolesError, RoleControllerDeleteCustomRolesResponse, RoleControllerUpdateCustomRoleData, RoleControllerUpdateCustomRoleError, RoleControllerUpdateCustomRoleResponse, RoleControllerGetRoleDetailsData, RoleControllerGetRoleDetailsError, RoleControllerGetRoleDetailsResponse, TokensControllerUploadWebPushTokenData, TokensControllerUploadWebPushTokenError, TokensControllerUploadWebPushTokenResponse, TokensControllerCreateMesTokenData, TokensControllerCreateMesTokenError, TokensControllerCreateMesTokenResponse, TokensControllerUpdateMesTokenData, TokensControllerUpdateMesTokenError, TokensControllerUpdateMesTokenResponse, UserControllerClaimUsersData, UserControllerClaimUsersError, UserControllerClaimUsersResponse, UserControllerUpdateUserRoleData, UserControllerUpdateUserRoleError, UserControllerUpdateUserRoleResponse, UserControllerUnclaimUsersData, UserControllerUnclaimUsersError, UserControllerUnclaimUsersResponse, UserControllerGetUserListData, UserControllerGetUserListError, UserControllerGetUserListResponse, UserControllerGetUserInfoData, UserControllerGetUserInfoError, UserControllerGetUserInfoResponse, UserControllerGetUserSettingsData, UserControllerGetUserSettingsError, UserControllerGetUserSettingsResponse, UserControllerUpsertUserSettingsData, UserControllerUpsertUserSettingsError, UserControllerUpsertUserSettingsResponse, RefreshTokenControllerRefreshAccessTokenError, RefreshTokenControllerRefreshAccessTokenResponse, AnalyticsFilterControllerCreateAnalyticsFilterData, AnalyticsFilterControllerCreateAnalyticsFilterError, AnalyticsFilterControllerCreateAnalyticsFilterResponse, AnalyticsFilterControllerGetAnalyticsFilterListData, AnalyticsFilterControllerGetAnalyticsFilterListError, AnalyticsFilterControllerGetAnalyticsFilterListResponse, AnalyticsFilterControllerUpdateAnalyticsFilterData, AnalyticsFilterControllerUpdateAnalyticsFilterError, AnalyticsFilterControllerUpdateAnalyticsFilterResponse, AnalyticsFilterControllerDeleteAnalyticsFilterData, AnalyticsFilterControllerDeleteAnalyticsFilterError, AnalyticsFilterControllerDeleteAnalyticsFilterResponse, DashboardV2ControllerGetDashboardsData, DashboardV2ControllerGetDashboardsError, DashboardV2ControllerGetDashboardsResponse, DashboardV2ControllerGetDashboardByIdData, DashboardV2ControllerGetDashboardByIdError, DashboardV2ControllerGetDashboardByIdResponse, DashboardV2ControllerUpdateDashboardData, DashboardV2ControllerUpdateDashboardError, DashboardV2ControllerUpdateDashboardResponse, DashboardV3ControllerCreateDashboardData, DashboardV3ControllerCreateDashboardError, DashboardV3ControllerCreateDashboardResponse, DashboardV3ControllerUpdateDashboardData, DashboardV3ControllerUpdateDashboardError, DashboardV3ControllerUpdateDashboardResponse, DashboardV3ControllerDeleteDashboardData, DashboardV3ControllerDeleteDashboardError, DashboardV3ControllerDeleteDashboardResponse, DashboardV3ControllerUpdateDashboardNameData, DashboardV3ControllerUpdateDashboardNameError, DashboardV3ControllerUpdateDashboardNameResponse, WidgetV2ControllerCreateWidgetData, WidgetV2ControllerCreateWidgetError, WidgetV2ControllerCreateWidgetResponse, WidgetV2ControllerGetWidgetsData, WidgetV2ControllerGetWidgetsError, WidgetV2ControllerGetWidgetsResponse, WidgetV2ControllerGetWidgetByIdData, WidgetV2ControllerGetWidgetByIdError, WidgetV2ControllerGetWidgetByIdResponse, WidgetV2ControllerUpdateWidgetData, WidgetV2ControllerUpdateWidgetError, WidgetV2ControllerUpdateWidgetResponse, WidgetV2ControllerDeleteWidgetData, WidgetV2ControllerDeleteWidgetError, WidgetV2ControllerDeleteWidgetResponse, WidgetV3ControllerGetWidgetsData, WidgetV3ControllerGetWidgetsError, WidgetV3ControllerGetWidgetsResponse, WidgetV3ControllerCreateWidgetData, WidgetV3ControllerCreateWidgetError, WidgetV3ControllerCreateWidgetResponse, WidgetV3ControllerGetWidgetData, WidgetV3ControllerGetWidgetError, WidgetV3ControllerGetWidgetResponse, WidgetV3ControllerUpdateWidgetData, WidgetV3ControllerUpdateWidgetError, WidgetV3ControllerUpdateWidgetResponse, WidgetV3ControllerDeleteWidgetData, WidgetV3ControllerDeleteWidgetError, WidgetV3ControllerDeleteWidgetResponse, MapV2ControllerCreateMapWidgetData, MapV2ControllerCreateMapWidgetError, MapV2ControllerCreateMapWidgetResponse, MapV2ControllerUpdateWidgetAndMapsData, MapV2ControllerUpdateWidgetAndMapsError, MapV2ControllerUpdateWidgetAndMapsResponse, MapV2ControllerGetMapsWithoutImageData, MapV2ControllerGetMapsWithoutImageError, MapV2ControllerGetMapsWithoutImageResponse, MapV2ControllerDeleteMapsData, MapV2ControllerDeleteMapsError, MapV2ControllerDeleteMapsResponse, MapV2ControllerGetMapData, MapV2ControllerGetMapError, MapV2ControllerGetMapResponse, MapV2ControllerDeleteMapData, MapV2ControllerDeleteMapError, MapV2ControllerDeleteMapResponse, DashboardTreeControllerGetDashboardTreesData, DashboardTreeControllerGetDashboardTreesError, DashboardTreeControllerGetDashboardTreesResponse, DashboardTreeControllerCreateRootChildData, DashboardTreeControllerCreateRootChildError, DashboardTreeControllerCreateRootChildResponse, DashboardTreeControllerUpdateRootChildData, DashboardTreeControllerUpdateRootChildError, DashboardTreeControllerUpdateRootChildResponse, DashboardTreeControllerUpdateChildNodePositionData, DashboardTreeControllerUpdateChildNodePositionError, DashboardTreeControllerUpdateChildNodePositionResponse, DashboardTreeControllerUpdateNodeNameData, DashboardTreeControllerUpdateNodeNameError, DashboardTreeControllerUpdateNodeNameResponse, DashboardTreeControllerDeleteNodeData, DashboardTreeControllerDeleteNodeError, DashboardTreeControllerDeleteNodeResponse, DashboardGroupControllerCreateDashboardGroupData, DashboardGroupControllerCreateDashboardGroupError, DashboardGroupControllerCreateDashboardGroupResponse, DashboardGroupControllerUpdateDashboardGroupData, DashboardGroupControllerUpdateDashboardGroupError, DashboardGroupControllerUpdateDashboardGroupResponse, DashboardGroupControllerDeleteDashboardGroupData, DashboardGroupControllerDeleteDashboardGroupError, DashboardGroupControllerDeleteDashboardGroupResponse, EventV1ControllerCreateMesEventData, EventV1ControllerCreateMesEventError, EventV1ControllerCreateMesEventResponse, EventV2ControllerGetEventsByDeviceData, EventV2ControllerGetEventsByDeviceError, EventV2ControllerGetEventsByDeviceResponse, EventV2ControllerGetTotalCountOfEventsData, EventV2ControllerGetTotalCountOfEventsError, EventV2ControllerGetTotalCountOfEventsResponse, EventV2ControllerGetMesEventsData, EventV2ControllerGetMesEventsError, EventV2ControllerGetMesEventsResponse, EventV2ControllerUpdateEventStatusData, EventV2ControllerUpdateEventStatusError, EventV2ControllerUpdateEventStatusResponse, NotificationControllerGetNotificationsData, NotificationControllerGetNotificationsError, NotificationControllerGetNotificationsResponse, NotificationControllerGetTotalAndUnreadTotalData, NotificationControllerGetTotalAndUnreadTotalError, NotificationControllerGetTotalAndUnreadTotalResponse, NotificationControllerMarkNotificationAsReadData, NotificationControllerMarkNotificationAsReadError, NotificationControllerMarkNotificationAsReadResponse, CrowdCountControllerGetCrowdSafetyV3Data, CrowdCountControllerGetCrowdSafetyV3Error, CrowdCountControllerGetCrowdSafetyV3Response, CrowdCountControllerGetCrowdCountAnalyticsData, CrowdCountControllerGetCrowdCountAnalyticsError, CrowdCountControllerGetCrowdCountAnalyticsResponse, CrowdCountControllerGetCrowdCountCategoryAnalyticsData, CrowdCountControllerGetCrowdCountCategoryAnalyticsError, CrowdCountControllerGetCrowdCountCategoryAnalyticsResponse, PeopleCountControllerGetCumulativePeopleData, PeopleCountControllerGetCumulativePeopleError, PeopleCountControllerGetCumulativePeopleResponse, PeopleCountControllerGetPeopleInOutData, PeopleCountControllerGetPeopleInOutError, PeopleCountControllerGetPeopleInOutResponse, PeopleCountControllerGetStayingPeopleData, PeopleCountControllerGetStayingPeopleError, PeopleCountControllerGetStayingPeopleResponse, PeopleCountControllerGetVisitorRankingData, PeopleCountControllerGetVisitorRankingError, PeopleCountControllerGetVisitorRankingResponse, PeopleCountControllerGetMapObjectCountingData, PeopleCountControllerGetMapObjectCountingError, PeopleCountControllerGetMapObjectCountingResponse, PeopleCountControllerGetCumulativePeopleAnalyticsData, PeopleCountControllerGetCumulativePeopleAnalyticsError, PeopleCountControllerGetCumulativePeopleAnalyticsResponse, PeopleCountControllerGetStayingPeopleAnalyticsData, PeopleCountControllerGetStayingPeopleAnalyticsError, PeopleCountControllerGetStayingPeopleAnalyticsResponse, PeopleCountControllerGetPeopleFlowAnalyticsData, PeopleCountControllerGetPeopleFlowAnalyticsError, PeopleCountControllerGetPeopleFlowAnalyticsResponse, PeopleCountControllerGetCumulativePeopleCategoryAnalyticsData, PeopleCountControllerGetCumulativePeopleCategoryAnalyticsError, PeopleCountControllerGetCumulativePeopleCategoryAnalyticsResponse, PeopleCountControllerGetStayingPeopleCategoryAnalyticsData, PeopleCountControllerGetStayingPeopleCategoryAnalyticsError, PeopleCountControllerGetStayingPeopleCategoryAnalyticsResponse, QueueManagementControllerGetCheckoutQueueData, QueueManagementControllerGetCheckoutQueueError, QueueManagementControllerGetCheckoutQueueResponse, QueueManagementControllerGetShoppingCartCheckoutQueueData, QueueManagementControllerGetShoppingCartCheckoutQueueError, QueueManagementControllerGetShoppingCartCheckoutQueueResponse, QueueManagementControllerGetVehicleQueueData, QueueManagementControllerGetVehicleQueueError, QueueManagementControllerGetVehicleQueueResponse, QueueManagementControllerGetAreaPeopleCountData, QueueManagementControllerGetAreaPeopleCountError, QueueManagementControllerGetAreaPeopleCountResponse, QueueManagementControllerGetVehicleQueueAnalyticsData, QueueManagementControllerGetVehicleQueueAnalyticsError, QueueManagementControllerGetVehicleQueueAnalyticsResponse, QueueManagementControllerGetShoppingCartCheckoutQueueAnalyticsData, QueueManagementControllerGetShoppingCartCheckoutQueueAnalyticsError, QueueManagementControllerGetShoppingCartCheckoutQueueAnalyticsResponse, QueueManagementControllerGetCheckoutQueueAnalyticsData, QueueManagementControllerGetCheckoutQueueAnalyticsError, QueueManagementControllerGetCheckoutQueueAnalyticsResponse, QueueManagementControllerGetCheckoutQueueCategoryAnalyticsData, QueueManagementControllerGetCheckoutQueueCategoryAnalyticsError, QueueManagementControllerGetCheckoutQueueCategoryAnalyticsResponse, QueueManagementControllerGetShoppingCartCheckoutQueueCategoryAnalyticsData, QueueManagementControllerGetShoppingCartCheckoutQueueCategoryAnalyticsError, QueueManagementControllerGetShoppingCartCheckoutQueueCategoryAnalyticsResponse, QueueManagementControllerGetRetailVisitorAreaTrafficData, QueueManagementControllerGetRetailVisitorAreaTrafficError, QueueManagementControllerGetRetailVisitorAreaTrafficResponse, QueueManagementControllerGetRetailVisitorAreaTrafficLatestDataData, QueueManagementControllerGetRetailVisitorAreaTrafficLatestDataError, QueueManagementControllerGetRetailVisitorAreaTrafficLatestDataResponse, QueueManagementControllerGetVehicleQueueCategoryAnalyticsData, QueueManagementControllerGetVehicleQueueCategoryAnalyticsError, QueueManagementControllerGetVehicleQueueCategoryAnalyticsResponse, ShoppingCartCountControllerGetShoppingCartCountsData, ShoppingCartCountControllerGetShoppingCartCountsError, ShoppingCartCountControllerGetShoppingCartCountsResponse, ShoppingCartCountControllerGetCurrentShoppingCartCountData, ShoppingCartCountControllerGetCurrentShoppingCartCountError, ShoppingCartCountControllerGetCurrentShoppingCartCountResponse, ShoppingCartCountControllerGetCumulativeShoppingCartAnalyticsData, ShoppingCartCountControllerGetCumulativeShoppingCartAnalyticsError, ShoppingCartCountControllerGetCumulativeShoppingCartAnalyticsResponse, ShoppingCartCountControllerGetShoppingCartInUseAnalyticsData, ShoppingCartCountControllerGetShoppingCartInUseAnalyticsError, ShoppingCartCountControllerGetShoppingCartInUseAnalyticsResponse, ShoppingCartCountControllerGetCumulativeShoppingCartCategoryAnalyticsData, ShoppingCartCountControllerGetCumulativeShoppingCartCategoryAnalyticsError, ShoppingCartCountControllerGetCumulativeShoppingCartCategoryAnalyticsResponse, ShoppingCartCountControllerGetShoppingCartInUseCategoryAnalyticsData, ShoppingCartCountControllerGetShoppingCartInUseCategoryAnalyticsError, ShoppingCartCountControllerGetShoppingCartInUseCategoryAnalyticsResponse, SlipAndFallControllerGetSlipAndFallCountsData, SlipAndFallControllerGetSlipAndFallCountsError, SlipAndFallControllerGetSlipAndFallCountsResponse, StoppedVehicleControllerGetStoppedVehicleData, StoppedVehicleControllerGetStoppedVehicleError, StoppedVehicleControllerGetStoppedVehicleResponse, StoppedVehicleControllerGetStoppedVehicleAnalyticsData, StoppedVehicleControllerGetStoppedVehicleAnalyticsError, StoppedVehicleControllerGetStoppedVehicleAnalyticsResponse, StoppedVehicleControllerGetStoppedVehicleCategoryAnalyticsData, StoppedVehicleControllerGetStoppedVehicleCategoryAnalyticsError, StoppedVehicleControllerGetStoppedVehicleCategoryAnalyticsResponse, VehicleCountControllerGetVehicleCountsData, VehicleCountControllerGetVehicleCountsError, VehicleCountControllerGetVehicleCountsResponse, VehicleCountControllerGetVehicleCountAnalyticsData, VehicleCountControllerGetVehicleCountAnalyticsError, VehicleCountControllerGetVehicleCountAnalyticsResponse, VehicleCountControllerGetVehicleInOutData, VehicleCountControllerGetVehicleInOutError, VehicleCountControllerGetVehicleInOutResponse, VehicleCountControllerGetVehicleFlowAnalyticsData, VehicleCountControllerGetVehicleFlowAnalyticsError, VehicleCountControllerGetVehicleFlowAnalyticsResponse, VehicleCountControllerGetStayingVehicleData, VehicleCountControllerGetStayingVehicleError, VehicleCountControllerGetStayingVehicleResponse, VehicleCountControllerGetStayingVehicleAnalyticsData, VehicleCountControllerGetStayingVehicleAnalyticsError, VehicleCountControllerGetStayingVehicleAnalyticsResponse, VehicleCountControllerGetVehicleCountCategoryAnalyticsData, VehicleCountControllerGetVehicleCountCategoryAnalyticsError, VehicleCountControllerGetVehicleCountCategoryAnalyticsResponse, VehicleCountControllerGetStayingVehicleCategoryAnalyticsData, VehicleCountControllerGetStayingVehicleCategoryAnalyticsError, VehicleCountControllerGetStayingVehicleCategoryAnalyticsResponse, ReportControllerCreateReportData, ReportControllerCreateReportError, ReportControllerCreateReportResponse, ReportControllerGetReportsData, ReportControllerGetReportsError, ReportControllerGetReportsResponse, ReportControllerUpdateReportData, ReportControllerUpdateReportError, ReportControllerUpdateReportResponse, ReportControllerDeleteReportData, ReportControllerDeleteReportError, ReportControllerDeleteReportResponse, ReportControllerGetReportDetailsData, ReportControllerGetReportDetailsError, ReportControllerGetReportDetailsResponse, ReportControllerGenerateReportPdfData, ReportControllerGenerateReportPdfError, ReportControllerGenerateReportPdfResponse, ReportControllerGenerateWidgetInsightData, ReportControllerGenerateWidgetInsightError, ReportControllerGenerateWidgetInsightResponse, ReportControllerMailReportPdfData, ReportControllerMailReportPdfError, ReportControllerMailReportPdfResponse, ReportControllerShareReportData, ReportControllerShareReportError, ReportControllerShareReportResponse, SlowTrafficControllerGetSlowTrafficCountsData, SlowTrafficControllerGetSlowTrafficCountsError, SlowTrafficControllerGetSlowTrafficCountsResponse, ExportDataControllerExportDataToCsvData, ExportDataControllerExportDataToCsvError, ExportDataControllerExportDataToCsvResponse, ExportDataControllerExportAnalyticsDataToCsvData, ExportDataControllerExportAnalyticsDataToCsvError, ExportDataControllerExportAnalyticsDataToCsvResponse, ShoppingCartLossControllerGetShoppingCartLossCountsData, ShoppingCartLossControllerGetShoppingCartLossCountsError, ShoppingCartLossControllerGetShoppingCartLossCountsResponse, ForkliftSpeedControllerGetForkliftSpeedCountsData, ForkliftSpeedControllerGetForkliftSpeedCountsError, ForkliftSpeedControllerGetForkliftSpeedCountsResponse, MapMarkerCountControllerGetMapMarkerCountingData, MapMarkerCountControllerGetMapMarkerCountingError, MapMarkerCountControllerGetMapMarkerCountingResponse, EventStatisticsControllerGetEventStatisticsData, EventStatisticsControllerGetEventStatisticsError, EventStatisticsControllerGetEventStatisticsResponse, EventStatisticsControllerGetEventTrendChartData, EventStatisticsControllerGetEventTrendChartError, EventStatisticsControllerGetEventTrendChartResponse, EventStatisticsControllerGetSlipAndFallAnalyticsData, EventStatisticsControllerGetSlipAndFallAnalyticsError, EventStatisticsControllerGetSlipAndFallAnalyticsResponse, EventStatisticsControllerGetSlipAndFallCategoryAnalyticsData, EventStatisticsControllerGetSlipAndFallCategoryAnalyticsError, EventStatisticsControllerGetSlipAndFallCategoryAnalyticsResponse, EventStatisticsControllerGetSlowTrafficAnalyticsData, EventStatisticsControllerGetSlowTrafficAnalyticsError, EventStatisticsControllerGetSlowTrafficAnalyticsResponse, EventStatisticsControllerGetSlowTrafficCategoryAnalyticsData, EventStatisticsControllerGetSlowTrafficCategoryAnalyticsError, EventStatisticsControllerGetSlowTrafficCategoryAnalyticsResponse, AiInsightControllerSendPromptData, AiInsightControllerSendPromptError, AiInsightControllerSendPromptResponse, DeviceControllerClaimDeviceData, DeviceControllerClaimDeviceError, DeviceControllerClaimDeviceResponse, DeviceControllerGetPortalDevicesData, DeviceControllerGetPortalDevicesError, DeviceControllerGetPortalDevicesResponse, DeviceControllerUpdateClaimDeviceData, DeviceControllerUpdateClaimDeviceError, DeviceControllerUpdateClaimDeviceResponse, DeviceControllerUpdateAllClaimDeviceData, DeviceControllerUpdateAllClaimDeviceError, DeviceControllerUpdateAllClaimDeviceResponse, DeviceControllerUnclaimDeviceData, DeviceControllerUnclaimDeviceError, DeviceControllerUnclaimDeviceResponse, DeviceControllerUnclaimBulkDevicesData, DeviceControllerUnclaimBulkDevicesError, DeviceControllerUnclaimBulkDevicesResponse, DeviceControllerGetDeviceConfigListData, DeviceControllerGetDeviceConfigListError, DeviceControllerGetDeviceConfigListResponse, DeviceControllerGetDeviceConfigData, DeviceControllerGetDeviceConfigError, DeviceControllerGetDeviceConfigResponse, DeviceControllerGetDeviceSnapshotData, DeviceControllerGetDeviceSnapshotError, DeviceControllerGetDeviceSnapshotResponse, LicenseControllerGetLicensesData, LicenseControllerGetLicensesError, LicenseControllerGetLicensesResponse, LicenseControllerOnCloudLicensebyDeviceIdData, LicenseControllerOnCloudLicensebyDeviceIdError, LicenseControllerOnCloudLicensebyDeviceIdResponse, LicenseControllerAttachLicensesData, LicenseControllerAttachLicensesError, LicenseControllerAttachLicensesResponse, LicenseControllerDetachLicensesData, LicenseControllerDetachLicensesError, LicenseControllerDetachLicensesResponse, SdcsControllerSendCommandData, SdcsControllerSendCommandError, SdcsControllerSendCommandResponse, SdcsControllerCheckWiseAiData, SdcsControllerCheckWiseAiError, SdcsControllerCheckWiseAiResponse, WavesyncControllerLinkData, WavesyncControllerLinkError, WavesyncControllerLinkResponse, WavesyncControllerUnlinkData, WavesyncControllerUnlinkError, WavesyncControllerUnlinkResponse, WavesyncControllerGetLinkStatusData, WavesyncControllerGetLinkStatusError, WavesyncControllerGetLinkStatusResponse, WavesyncControllerGetDevicesData, WavesyncControllerGetDevicesError, WavesyncControllerGetDevicesResponse, WavesyncControllerGetHlsData, WavesyncControllerGetHlsError, WavesyncControllerGetHlsResponse } from './types.gen';

export const client = createClient(createConfig());

/**
 * Get the version of the app
 */
export const gatewayControllerVersion = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GatewayControllerVersionResponse, GatewayControllerVersionError, ThrowOnError>({
        ...options,
        url: '/version'
    });
};

/**
 * Get information from the partner app.
 */
export const appInfoControllerGetPartnerAppInfo = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<AppInfoControllerGetPartnerAppInfoResponse, AppInfoControllerGetPartnerAppInfoError, ThrowOnError>({
        ...options,
        url: '/partner-app'
    });
};

/**
 * Get audit log list
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-report-menu
 */
export const auditLogControllerGetAuditLogs = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<AuditLogControllerGetAuditLogsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AuditLogControllerGetAuditLogsResponse, AuditLogControllerGetAuditLogsError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/audit-logs'
    });
};

export const authControllerLogout = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<AuthControllerLogoutResponse, AuthControllerLogoutError, ThrowOnError>({
        ...options,
        url: '/v1/auth/logout'
    });
};

export const authControllerUpdateUserLastAccess = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<AuthControllerUpdateUserLastAccessResponse, AuthControllerUpdateUserLastAccessError, ThrowOnError>({
        ...options,
        url: '/v1/auth/access-token/update-lastAccess'
    });
};

export const authControllerGetUserLastAccess = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<AuthControllerGetUserLastAccessResponse, AuthControllerGetUserLastAccessError, ThrowOnError>({
        ...options,
        url: '/v1/auth/access-token/lastAccess'
    });
};

/**
 * create app default permissions, add super admin into super-member group
 */
export const organizationManagementControllerCreateAppDefaultPermission = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<OrganizationManagementControllerCreateAppDefaultPermissionData, ThrowOnError>) => {
    return (options?.client ?? client).post<OrganizationManagementControllerCreateAppDefaultPermissionResponse, OrganizationManagementControllerCreateAppDefaultPermissionError, ThrowOnError>({
        ...options,
        url: '/v1/organization-management/app-default-permission'
    });
};

/**
 * Get organization list
 */
export const organizationControllerGetUserOrgList = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<OrganizationControllerGetUserOrgListResponse, OrganizationControllerGetUserOrgListError, ThrowOnError>({
        ...options,
        url: '/v1/organizations'
    });
};

/**
 * Get connected organizations list
 */
export const organizationControllerGetAccessibleOrgList = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<OrganizationControllerGetAccessibleOrgListResponse, OrganizationControllerGetAccessibleOrgListError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/accessible'
    });
};

/**
 * Get last organization
 */
export const organizationControllerGetLastAccessOrg = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<OrganizationControllerGetLastAccessOrgResponse, OrganizationControllerGetLastAccessOrgError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/lastAccessOrg'
    });
};

/**
 * Update organization
 */
export const organizationControllerUpdateOrg = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<OrganizationControllerUpdateOrgData, ThrowOnError>) => {
    return (options?.client ?? client).put<OrganizationControllerUpdateOrgResponse, OrganizationControllerUpdateOrgError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/lastAccessOrg/{orgId}'
    });
};

/**
 * Create a custom role
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-user-management-menu
 */
export const roleControllerCreateCustomRole = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<RoleControllerCreateCustomRoleData, ThrowOnError>) => {
    return (options?.client ?? client).post<RoleControllerCreateCustomRoleResponse, RoleControllerCreateCustomRoleError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/roles'
    });
};

/**
 * Get roles
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-user-management-menu
 */
export const roleControllerGetRoles = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<RoleControllerGetRolesData, ThrowOnError>) => {
    return (options?.client ?? client).get<RoleControllerGetRolesResponse, RoleControllerGetRolesError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/roles'
    });
};

/**
 * Delete custom roles
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-user-management-menu
 */
export const roleControllerDeleteCustomRoles = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<RoleControllerDeleteCustomRolesData, ThrowOnError>) => {
    return (options?.client ?? client).delete<RoleControllerDeleteCustomRolesResponse, RoleControllerDeleteCustomRolesError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/roles'
    });
};

/**
 * Update a custom role
 */
export const roleControllerUpdateCustomRole = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<RoleControllerUpdateCustomRoleData, ThrowOnError>) => {
    return (options?.client ?? client).patch<RoleControllerUpdateCustomRoleResponse, RoleControllerUpdateCustomRoleError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/roles/{roleId}'
    });
};

/**
 * Get role details
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-user-management-menu
 */
export const roleControllerGetRoleDetails = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<RoleControllerGetRoleDetailsData, ThrowOnError>) => {
    return (options?.client ?? client).get<RoleControllerGetRoleDetailsResponse, RoleControllerGetRoleDetailsError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/roles/{roleId}'
    });
};

export const tokensControllerUploadWebPushToken = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<TokensControllerUploadWebPushTokenData, ThrowOnError>) => {
    return (options?.client ?? client).post<TokensControllerUploadWebPushTokenResponse, TokensControllerUploadWebPushTokenError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/tokens/web-push'
    });
};

export const tokensControllerCreateMesToken = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<TokensControllerCreateMesTokenData, ThrowOnError>) => {
    return (options?.client ?? client).post<TokensControllerCreateMesTokenResponse, TokensControllerCreateMesTokenError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/tokens/mes'
    });
};

export const tokensControllerUpdateMesToken = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<TokensControllerUpdateMesTokenData, ThrowOnError>) => {
    return (options?.client ?? client).put<TokensControllerUpdateMesTokenResponse, TokensControllerUpdateMesTokenError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/tokens/mes'
    });
};

/**
 * Claim users
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-user-management-menu
 */
export const userControllerClaimUsers = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<UserControllerClaimUsersData, ThrowOnError>) => {
    return (options?.client ?? client).post<UserControllerClaimUsersResponse, UserControllerClaimUsersError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/users'
    });
};

/**
 * Update user role
 */
export const userControllerUpdateUserRole = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<UserControllerUpdateUserRoleData, ThrowOnError>) => {
    return (options?.client ?? client).put<UserControllerUpdateUserRoleResponse, UserControllerUpdateUserRoleError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/users'
    });
};

/**
 * Unclaim users
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-user-management-menu
 */
export const userControllerUnclaimUsers = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<UserControllerUnclaimUsersData, ThrowOnError>) => {
    return (options?.client ?? client).delete<UserControllerUnclaimUsersResponse, UserControllerUnclaimUsersError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/users'
    });
};

/**
 * Get User list
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-user-management-menu
 *
 * * can-view-report-menu
 */
export const userControllerGetUserList = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<UserControllerGetUserListData, ThrowOnError>) => {
    return (options?.client ?? client).get<UserControllerGetUserListResponse, UserControllerGetUserListError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/users'
    });
};

/**
 * Get User info
 */
export const userControllerGetUserInfo = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<UserControllerGetUserInfoData, ThrowOnError>) => {
    return (options?.client ?? client).get<UserControllerGetUserInfoResponse, UserControllerGetUserInfoError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/user'
    });
};

/**
 * Get user settings
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const userControllerGetUserSettings = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<UserControllerGetUserSettingsData, ThrowOnError>) => {
    return (options?.client ?? client).get<UserControllerGetUserSettingsResponse, UserControllerGetUserSettingsError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/settings'
    });
};

/**
 * Create or Update user settings
 *
 *
 * ### One of the permissions is required:
 *
 * * can-sequence-dashboard
 */
export const userControllerUpsertUserSettings = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<UserControllerUpsertUserSettingsData, ThrowOnError>) => {
    return (options?.client ?? client).put<UserControllerUpsertUserSettingsResponse, UserControllerUpsertUserSettingsError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/settings'
    });
};

/**
 * Refresh Token
 * The token in the cookie is refreshed and returned.
 */
export const refreshTokenControllerRefreshAccessToken = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<RefreshTokenControllerRefreshAccessTokenResponse, RefreshTokenControllerRefreshAccessTokenError, ThrowOnError>({
        ...options,
        url: '/v1/auth/access-token/refresh'
    });
};

/**
 * Creates analytics filter
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const analyticsFilterControllerCreateAnalyticsFilter = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<AnalyticsFilterControllerCreateAnalyticsFilterData, ThrowOnError>) => {
    return (options?.client ?? client).post<AnalyticsFilterControllerCreateAnalyticsFilterResponse, AnalyticsFilterControllerCreateAnalyticsFilterError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/analytics-filter'
    });
};

/**
 * Get filter list and data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const analyticsFilterControllerGetAnalyticsFilterList = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<AnalyticsFilterControllerGetAnalyticsFilterListData, ThrowOnError>) => {
    return (options?.client ?? client).get<AnalyticsFilterControllerGetAnalyticsFilterListResponse, AnalyticsFilterControllerGetAnalyticsFilterListError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/analytics-filter'
    });
};

/**
 * Update analytics filter
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const analyticsFilterControllerUpdateAnalyticsFilter = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<AnalyticsFilterControllerUpdateAnalyticsFilterData, ThrowOnError>) => {
    return (options?.client ?? client).put<AnalyticsFilterControllerUpdateAnalyticsFilterResponse, AnalyticsFilterControllerUpdateAnalyticsFilterError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/analytics-filter/{filterId}'
    });
};

/**
 * Delete analytics filter
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const analyticsFilterControllerDeleteAnalyticsFilter = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<AnalyticsFilterControllerDeleteAnalyticsFilterData, ThrowOnError>) => {
    return (options?.client ?? client).delete<AnalyticsFilterControllerDeleteAnalyticsFilterResponse, AnalyticsFilterControllerDeleteAnalyticsFilterError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/analytics-filter/{filterId}'
    });
};

/**
 * Get dashboard list by userId
 * limit: 8
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const dashboardV2ControllerGetDashboards = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardV2ControllerGetDashboardsData, ThrowOnError>) => {
    return (options?.client ?? client).get<DashboardV2ControllerGetDashboardsResponse, DashboardV2ControllerGetDashboardsError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/dashboards'
    });
};

/**
 * Get dashboard list by id
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const dashboardV2ControllerGetDashboardById = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardV2ControllerGetDashboardByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<DashboardV2ControllerGetDashboardByIdResponse, DashboardV2ControllerGetDashboardByIdError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/dashboards/{dashboardId}'
    });
};

/**
 * @deprecated
 * Update dashboard
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-dashboard
 *
 * * can-relocating-resizing-widget
 */
export const dashboardV2ControllerUpdateDashboard = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardV2ControllerUpdateDashboardData, ThrowOnError>) => {
    return (options?.client ?? client).put<DashboardV2ControllerUpdateDashboardResponse, DashboardV2ControllerUpdateDashboardError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/dashboards/{dashboardId}'
    });
};

/**
 * Create new Dashboard
 * dashboards can be created per organization.
 *
 *
 *
 * (limit: unlimited)
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-dashboard
 */
export const dashboardV3ControllerCreateDashboard = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardV3ControllerCreateDashboardData, ThrowOnError>) => {
    return (options?.client ?? client).post<DashboardV3ControllerCreateDashboardResponse, DashboardV3ControllerCreateDashboardError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/dashboards'
    });
};

/**
 * Update Dashboard
 * Updates only the requested values about Dashboard.
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-dashboard
 */
export const dashboardV3ControllerUpdateDashboard = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardV3ControllerUpdateDashboardData, ThrowOnError>) => {
    return (options?.client ?? client).patch<DashboardV3ControllerUpdateDashboardResponse, DashboardV3ControllerUpdateDashboardError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/dashboards/{dashboardId}'
    });
};

/**
 * Delete Dashboard
 * Delete the Dashboard and remove it from any groups if it is belongs to a group
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-dashboard
 */
export const dashboardV3ControllerDeleteDashboard = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardV3ControllerDeleteDashboardData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DashboardV3ControllerDeleteDashboardResponse, DashboardV3ControllerDeleteDashboardError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/dashboards/{dashboardId}'
    });
};

/**
 * Update Dashboard name
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-dashboard
 */
export const dashboardV3ControllerUpdateDashboardName = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardV3ControllerUpdateDashboardNameData, ThrowOnError>) => {
    return (options?.client ?? client).patch<DashboardV3ControllerUpdateDashboardNameResponse, DashboardV3ControllerUpdateDashboardNameError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/dashboards/{dashboardId}/names'
    });
};

/**
 * Create widget
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-delete-show-hide-widget
 */
export const widgetV2ControllerCreateWidget = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WidgetV2ControllerCreateWidgetData, ThrowOnError>) => {
    return (options?.client ?? client).post<WidgetV2ControllerCreateWidgetResponse, WidgetV2ControllerCreateWidgetError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/dashboards/{dashboardId}/widgets'
    });
};

/**
 * Get widget list
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const widgetV2ControllerGetWidgets = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WidgetV2ControllerGetWidgetsData, ThrowOnError>) => {
    return (options?.client ?? client).get<WidgetV2ControllerGetWidgetsResponse, WidgetV2ControllerGetWidgetsError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/dashboards/{dashboardId}/widgets'
    });
};

/**
 * Get widget by id
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const widgetV2ControllerGetWidgetById = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WidgetV2ControllerGetWidgetByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<WidgetV2ControllerGetWidgetByIdResponse, WidgetV2ControllerGetWidgetByIdError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/dashboards/{dashboardId}/widgets/{widgetId}'
    });
};

/**
 * Update widget
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-delete-show-hide-widget
 *
 * * can-setting-widget
 */
export const widgetV2ControllerUpdateWidget = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WidgetV2ControllerUpdateWidgetData, ThrowOnError>) => {
    return (options?.client ?? client).put<WidgetV2ControllerUpdateWidgetResponse, WidgetV2ControllerUpdateWidgetError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/dashboards/{dashboardId}/widgets/{widgetId}'
    });
};

/**
 * Delete widget
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-delete-show-hide-widget
 */
export const widgetV2ControllerDeleteWidget = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WidgetV2ControllerDeleteWidgetData, ThrowOnError>) => {
    return (options?.client ?? client).delete<WidgetV2ControllerDeleteWidgetResponse, WidgetV2ControllerDeleteWidgetError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/dashboards/{dashboardId}/widgets/{widgetId}'
    });
};

/**
 * Get widget list
 * Get all widgets in the dashboard
 *
 *
 *
 * Viewable widget types : COMBINED_MAP
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const widgetV3ControllerGetWidgets = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WidgetV3ControllerGetWidgetsData, ThrowOnError>) => {
    return (options?.client ?? client).get<WidgetV3ControllerGetWidgetsResponse, WidgetV3ControllerGetWidgetsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/dashboards/{dashboardId}/widgets'
    });
};

/**
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-delete-show-hide-widget
 */
export const widgetV3ControllerCreateWidget = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WidgetV3ControllerCreateWidgetData, ThrowOnError>) => {
    return (options?.client ?? client).post<WidgetV3ControllerCreateWidgetResponse, WidgetV3ControllerCreateWidgetError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/dashboards/{dashboardId}/widgets'
    });
};

/**
 * Get widget
 * Get widget by widgetId
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const widgetV3ControllerGetWidget = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WidgetV3ControllerGetWidgetData, ThrowOnError>) => {
    return (options?.client ?? client).get<WidgetV3ControllerGetWidgetResponse, WidgetV3ControllerGetWidgetError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/dashboards/{dashboardId}/widgets/{widgetId}'
    });
};

/**
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-delete-show-hide-widget
 *
 * * can-setting-widget
 */
export const widgetV3ControllerUpdateWidget = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WidgetV3ControllerUpdateWidgetData, ThrowOnError>) => {
    return (options?.client ?? client).patch<WidgetV3ControllerUpdateWidgetResponse, WidgetV3ControllerUpdateWidgetError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/dashboards/{dashboardId}/widgets/{widgetId}'
    });
};

/**
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-delete-show-hide-widget
 */
export const widgetV3ControllerDeleteWidget = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WidgetV3ControllerDeleteWidgetData, ThrowOnError>) => {
    return (options?.client ?? client).delete<WidgetV3ControllerDeleteWidgetResponse, WidgetV3ControllerDeleteWidgetError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/dashboards/{dashboardId}/widgets/{widgetId}'
    });
};

/**
 * create widget, upload maps, create maps
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-delete-show-hide-widget
 */
export const mapV2ControllerCreateMapWidget = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<MapV2ControllerCreateMapWidgetData, ThrowOnError>) => {
    return (options?.client ?? client).post<MapV2ControllerCreateMapWidgetResponse, MapV2ControllerCreateMapWidgetError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/dashboards/{dashboardId}/maps'
    });
};

/**
 * For update widget's name, styleType, type and maps' image info, name, deviceRules, options
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-delete-show-hide-widget
 *
 * * can-setting-widget
 */
export const mapV2ControllerUpdateWidgetAndMaps = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<MapV2ControllerUpdateWidgetAndMapsData, ThrowOnError>) => {
    return (options?.client ?? client).put<MapV2ControllerUpdateWidgetAndMapsResponse, MapV2ControllerUpdateWidgetAndMapsError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/dashboards/{dashboardId}/widgets/{widgetId}/maps'
    });
};

/**
 * get maps by widgetId without image info
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const mapV2ControllerGetMapsWithoutImage = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<MapV2ControllerGetMapsWithoutImageData, ThrowOnError>) => {
    return (options?.client ?? client).get<MapV2ControllerGetMapsWithoutImageResponse, MapV2ControllerGetMapsWithoutImageError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/dashboards/{dashboardId}/widgets/{widgetId}/maps'
    });
};

/**
 * delete maps, map images and the selected widget device rules
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-delete-show-hide-widget
 *
 * * can-setting-widget
 */
export const mapV2ControllerDeleteMaps = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<MapV2ControllerDeleteMapsData, ThrowOnError>) => {
    return (options?.client ?? client).delete<MapV2ControllerDeleteMapsResponse, MapV2ControllerDeleteMapsError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/dashboards/{dashboardId}/widgets/{widgetId}/maps'
    });
};

/**
 * get maps by widgetId or get map image by mapId
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const mapV2ControllerGetMap = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<MapV2ControllerGetMapData, ThrowOnError>) => {
    return (options?.client ?? client).get<MapV2ControllerGetMapResponse, MapV2ControllerGetMapError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/dashboards/{dashboardId}/widgets/{widgetId}/maps/{mapId}'
    });
};

/**
 * delete map, map image and the selected widget device rules
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-delete-show-hide-widget
 *
 * * can-setting-widget
 */
export const mapV2ControllerDeleteMap = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<MapV2ControllerDeleteMapData, ThrowOnError>) => {
    return (options?.client ?? client).delete<MapV2ControllerDeleteMapResponse, MapV2ControllerDeleteMapError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/dashboards/{dashboardId}/widgets/{widgetId}/maps/{mapId}'
    });
};

/**
 * Get DashboardTree
 * Get list of dashboard treeand value of Whether the number of dashboards is limited(limit: unlimited)
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const dashboardTreeControllerGetDashboardTrees = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardTreeControllerGetDashboardTreesData, ThrowOnError>) => {
    return (options?.client ?? client).get<DashboardTreeControllerGetDashboardTreesResponse, DashboardTreeControllerGetDashboardTreesError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/dashboard-trees'
    });
};

/**
 * Add root node's child node
 * Add child node to DashboardTree root node's children.
 *
 *
 *
 * Only can be added if the node type is TYPE_GROUP.
 *
 *
 *
 * Order priority: sibling > position > default(-1)
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-dashboard
 */
export const dashboardTreeControllerCreateRootChild = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardTreeControllerCreateRootChildData, ThrowOnError>) => {
    return (options?.client ?? client).post<DashboardTreeControllerCreateRootChildResponse, DashboardTreeControllerCreateRootChildError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/dashboard-trees/root/children'
    });
};

/**
 * Move child node
 * Move child node position
 *
 *
 *
 * If the child node is not belong to the node, it will be moved to the node.
 *
 *
 *
 * Order priority: sibling > position > default(0)
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-dashboard
 */
export const dashboardTreeControllerUpdateRootChild = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardTreeControllerUpdateRootChildData, ThrowOnError>) => {
    return (options?.client ?? client).patch<DashboardTreeControllerUpdateRootChildResponse, DashboardTreeControllerUpdateRootChildError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/dashboard-trees/root/children'
    });
};

/**
 * Move child node
 * Move child node position
 *
 *
 *
 * If the child node is not belong to the node, it will be moved to the node.
 *
 *
 *
 * Order priority: sibling > position > default(0)
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-dashboard
 */
export const dashboardTreeControllerUpdateChildNodePosition = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardTreeControllerUpdateChildNodePositionData, ThrowOnError>) => {
    return (options?.client ?? client).patch<DashboardTreeControllerUpdateChildNodePositionResponse, DashboardTreeControllerUpdateChildNodePositionError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/dashboard-trees/{nodeId}/children'
    });
};

/**
 * Update node name
 * Update node name
 *
 * It can only be updated if the node type is TYPE_GROUP.
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-dashboard
 */
export const dashboardTreeControllerUpdateNodeName = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardTreeControllerUpdateNodeNameData, ThrowOnError>) => {
    return (options?.client ?? client).patch<DashboardTreeControllerUpdateNodeNameResponse, DashboardTreeControllerUpdateNodeNameError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/dashboard-trees/{nodeId}/names'
    });
};

/**
 * Delete node
 * Delete node
 *
 * It can only be deleted if the node type is TYPE_GROUP.
 *
 * If the node has children, the children will be belongs to the parent node
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-dashboard
 */
export const dashboardTreeControllerDeleteNode = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardTreeControllerDeleteNodeData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DashboardTreeControllerDeleteNodeResponse, DashboardTreeControllerDeleteNodeError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/dashboard-trees/{nodeId}'
    });
};

/**
 * @deprecated
 * Create new DashboardGroup
 * It is same as '[POST] /v1/organizations/{orgId}/dashboard-trees/root/children' API.
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-dashboard
 */
export const dashboardGroupControllerCreateDashboardGroup = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardGroupControllerCreateDashboardGroupData, ThrowOnError>) => {
    return (options?.client ?? client).post<DashboardGroupControllerCreateDashboardGroupResponse, DashboardGroupControllerCreateDashboardGroupError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/dashboard-groups'
    });
};

/**
 * @deprecated
 * Update DashboardGroup
 * Updates only the requested values about DashboardGroup
 *
 * It is same as '[PATCH] /v1/organizations/{orgId}/dashboard-trees/{nodeId}/names' API.
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-dashboard
 */
export const dashboardGroupControllerUpdateDashboardGroup = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardGroupControllerUpdateDashboardGroupData, ThrowOnError>) => {
    return (options?.client ?? client).patch<DashboardGroupControllerUpdateDashboardGroupResponse, DashboardGroupControllerUpdateDashboardGroupError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/dashboard-groups/{groupId}/names'
    });
};

/**
 * @deprecated
 * Delete DashboardGroup
 * It is same as '[DELETE] /v1/organizations/{orgId}/dashboard-trees/{nodeId}' API.
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-dashboard
 */
export const dashboardGroupControllerDeleteDashboardGroup = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DashboardGroupControllerDeleteDashboardGroupData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DashboardGroupControllerDeleteDashboardGroupResponse, DashboardGroupControllerDeleteDashboardGroupError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/dashboard-groups/{groupId}'
    });
};

/**
 * create MES event
 */
export const eventV1ControllerCreateMesEvent = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<EventV1ControllerCreateMesEventData, ThrowOnError>) => {
    return (options?.client ?? client).post<EventV1ControllerCreateMesEventResponse, EventV1ControllerCreateMesEventError, ThrowOnError>({
        ...options,
        url: '/v1/events/mes'
    });
};

/**
 * Get a list of events by device
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-monitoring-dashboard
 */
export const eventV2ControllerGetEventsByDevice = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<EventV2ControllerGetEventsByDeviceData, ThrowOnError>) => {
    return (options?.client ?? client).get<EventV2ControllerGetEventsByDeviceResponse, EventV2ControllerGetEventsByDeviceError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/events'
    });
};

/**
 * Get total count of events
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 *
 * * can-search-event
 */
export const eventV2ControllerGetTotalCountOfEvents = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<EventV2ControllerGetTotalCountOfEventsData, ThrowOnError>) => {
    return (options?.client ?? client).get<EventV2ControllerGetTotalCountOfEventsResponse, EventV2ControllerGetTotalCountOfEventsError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/events/total'
    });
};

/**
 * Get a list of MES events
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 *
 * * can-search-event
 */
export const eventV2ControllerGetMesEvents = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<EventV2ControllerGetMesEventsData, ThrowOnError>) => {
    return (options?.client ?? client).get<EventV2ControllerGetMesEventsResponse, EventV2ControllerGetMesEventsError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/events/mes/{widgetId}'
    });
};

/**
 * Update the status of event
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 *
 * * can-search-event
 */
export const eventV2ControllerUpdateEventStatus = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<EventV2ControllerUpdateEventStatusData, ThrowOnError>) => {
    return (options?.client ?? client).put<EventV2ControllerUpdateEventStatusResponse, EventV2ControllerUpdateEventStatusError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/events/{eventId}'
    });
};

/**
 * Get a list of notifications
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const notificationControllerGetNotifications = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<NotificationControllerGetNotificationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<NotificationControllerGetNotificationsResponse, NotificationControllerGetNotificationsError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/notifications'
    });
};

/**
 * Get total count and unread total count
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const notificationControllerGetTotalAndUnreadTotal = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<NotificationControllerGetTotalAndUnreadTotalData, ThrowOnError>) => {
    return (options?.client ?? client).get<NotificationControllerGetTotalAndUnreadTotalResponse, NotificationControllerGetTotalAndUnreadTotalError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/notifications/total'
    });
};

/**
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const notificationControllerMarkNotificationAsRead = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<NotificationControllerMarkNotificationAsReadData, ThrowOnError>) => {
    return (options?.client ?? client).put<NotificationControllerMarkNotificationAsReadResponse, NotificationControllerMarkNotificationAsReadError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/notifications/{id}/mark'
    });
};

/**
 * Get crowd safety data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const crowdCountControllerGetCrowdSafetyV3 = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<CrowdCountControllerGetCrowdSafetyV3Data, ThrowOnError>) => {
    return (options?.client ?? client).get<CrowdCountControllerGetCrowdSafetyV3Response, CrowdCountControllerGetCrowdSafetyV3Error, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/crowd-safety/{widgetId}'
    });
};

/**
 * Get crowd count analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const crowdCountControllerGetCrowdCountAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<CrowdCountControllerGetCrowdCountAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<CrowdCountControllerGetCrowdCountAnalyticsResponse, CrowdCountControllerGetCrowdCountAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/crowd-count-analytics'
    });
};

/**
 * Get crowd count analytics data by category
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const crowdCountControllerGetCrowdCountCategoryAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<CrowdCountControllerGetCrowdCountCategoryAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<CrowdCountControllerGetCrowdCountCategoryAnalyticsResponse, CrowdCountControllerGetCrowdCountCategoryAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/crowd-count-category-analytics'
    });
};

/**
 * Get cumulative total people counts and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const peopleCountControllerGetCumulativePeople = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PeopleCountControllerGetCumulativePeopleData, ThrowOnError>) => {
    return (options?.client ?? client).get<PeopleCountControllerGetCumulativePeopleResponse, PeopleCountControllerGetCumulativePeopleError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/cumulative-people/{widgetId}'
    });
};

/**
 * Get average in/out people counts and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const peopleCountControllerGetPeopleInOut = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PeopleCountControllerGetPeopleInOutData, ThrowOnError>) => {
    return (options?.client ?? client).get<PeopleCountControllerGetPeopleInOutResponse, PeopleCountControllerGetPeopleInOutError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/people-in-out/{widgetId}'
    });
};

/**
 * Get the total staying people counts and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const peopleCountControllerGetStayingPeople = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PeopleCountControllerGetStayingPeopleData, ThrowOnError>) => {
    return (options?.client ?? client).get<PeopleCountControllerGetStayingPeopleResponse, PeopleCountControllerGetStayingPeopleError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/staying-people/{widgetId}'
    });
};

/**
 * Get visitor ranking data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const peopleCountControllerGetVisitorRanking = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PeopleCountControllerGetVisitorRankingData, ThrowOnError>) => {
    return (options?.client ?? client).get<PeopleCountControllerGetVisitorRankingResponse, PeopleCountControllerGetVisitorRankingError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/visitor-ranking/{widgetId}'
    });
};

/**
 * Get total people count, current people count and every device rule's in/out people count by mapId
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const peopleCountControllerGetMapObjectCounting = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PeopleCountControllerGetMapObjectCountingData, ThrowOnError>) => {
    return (options?.client ?? client).get<PeopleCountControllerGetMapObjectCountingResponse, PeopleCountControllerGetMapObjectCountingError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/map-object-counting/{mapId}'
    });
};

/**
 * Get cumulative people analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const peopleCountControllerGetCumulativePeopleAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PeopleCountControllerGetCumulativePeopleAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PeopleCountControllerGetCumulativePeopleAnalyticsResponse, PeopleCountControllerGetCumulativePeopleAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/cumulative-people-analytics'
    });
};

/**
 * Get staying people analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const peopleCountControllerGetStayingPeopleAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PeopleCountControllerGetStayingPeopleAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PeopleCountControllerGetStayingPeopleAnalyticsResponse, PeopleCountControllerGetStayingPeopleAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/staying-people-analytics'
    });
};

/**
 * Get people flow analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const peopleCountControllerGetPeopleFlowAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PeopleCountControllerGetPeopleFlowAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PeopleCountControllerGetPeopleFlowAnalyticsResponse, PeopleCountControllerGetPeopleFlowAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/people-flow-analytics'
    });
};

/**
 * Get cumulative people category analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const peopleCountControllerGetCumulativePeopleCategoryAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PeopleCountControllerGetCumulativePeopleCategoryAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PeopleCountControllerGetCumulativePeopleCategoryAnalyticsResponse, PeopleCountControllerGetCumulativePeopleCategoryAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/cumulative-people-category-analytics'
    });
};

/**
 * Get staying people category analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const peopleCountControllerGetStayingPeopleCategoryAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PeopleCountControllerGetStayingPeopleCategoryAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PeopleCountControllerGetStayingPeopleCategoryAnalyticsResponse, PeopleCountControllerGetStayingPeopleCategoryAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/staying-people-category-analytics'
    });
};

/**
 * Get average people counts, average people dwell times and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const queueManagementControllerGetCheckoutQueue = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<QueueManagementControllerGetCheckoutQueueData, ThrowOnError>) => {
    return (options?.client ?? client).get<QueueManagementControllerGetCheckoutQueueResponse, QueueManagementControllerGetCheckoutQueueError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/checkout-queue/{widgetId}'
    });
};

/**
 * Get average cart counts and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const queueManagementControllerGetShoppingCartCheckoutQueue = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<QueueManagementControllerGetShoppingCartCheckoutQueueData, ThrowOnError>) => {
    return (options?.client ?? client).get<QueueManagementControllerGetShoppingCartCheckoutQueueResponse, QueueManagementControllerGetShoppingCartCheckoutQueueError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/shopping-cart-checkout-queue/{widgetId}'
    });
};

/**
 * Get average vehicle counts and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const queueManagementControllerGetVehicleQueue = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<QueueManagementControllerGetVehicleQueueData, ThrowOnError>) => {
    return (options?.client ?? client).get<QueueManagementControllerGetVehicleQueueResponse, QueueManagementControllerGetVehicleQueueError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/vehicle-queue/{widgetId}'
    });
};

/**
 * Get the total number of people by area
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const queueManagementControllerGetAreaPeopleCount = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<QueueManagementControllerGetAreaPeopleCountData, ThrowOnError>) => {
    return (options?.client ?? client).get<QueueManagementControllerGetAreaPeopleCountResponse, QueueManagementControllerGetAreaPeopleCountError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/area-people-count/{widgetId}'
    });
};

/**
 * Get vehicle queue analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const queueManagementControllerGetVehicleQueueAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<QueueManagementControllerGetVehicleQueueAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<QueueManagementControllerGetVehicleQueueAnalyticsResponse, QueueManagementControllerGetVehicleQueueAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/vehicle-queue-analytics'
    });
};

/**
 * Get shopping cart checkout queue analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const queueManagementControllerGetShoppingCartCheckoutQueueAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<QueueManagementControllerGetShoppingCartCheckoutQueueAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<QueueManagementControllerGetShoppingCartCheckoutQueueAnalyticsResponse, QueueManagementControllerGetShoppingCartCheckoutQueueAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/shopping-cart-checkout-queue-analytics'
    });
};

/**
 * Get people queue analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const queueManagementControllerGetCheckoutQueueAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<QueueManagementControllerGetCheckoutQueueAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<QueueManagementControllerGetCheckoutQueueAnalyticsResponse, QueueManagementControllerGetCheckoutQueueAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/checkout-queue-analytics'
    });
};

/**
 * Get people queue analytics data by category
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const queueManagementControllerGetCheckoutQueueCategoryAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<QueueManagementControllerGetCheckoutQueueCategoryAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<QueueManagementControllerGetCheckoutQueueCategoryAnalyticsResponse, QueueManagementControllerGetCheckoutQueueCategoryAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/checkout-queue-category-analytics'
    });
};

/**
 * Get shopping cart checkout queue analytics data by category
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const queueManagementControllerGetShoppingCartCheckoutQueueCategoryAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<QueueManagementControllerGetShoppingCartCheckoutQueueCategoryAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<QueueManagementControllerGetShoppingCartCheckoutQueueCategoryAnalyticsResponse, QueueManagementControllerGetShoppingCartCheckoutQueueCategoryAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/shopping-cart-checkout-queue-category-analytics'
    });
};

/**
 * Get visitor area traffic data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const queueManagementControllerGetRetailVisitorAreaTraffic = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<QueueManagementControllerGetRetailVisitorAreaTrafficData, ThrowOnError>) => {
    return (options?.client ?? client).get<QueueManagementControllerGetRetailVisitorAreaTrafficResponse, QueueManagementControllerGetRetailVisitorAreaTrafficError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/visitor-area-traffic/{widgetId}'
    });
};

/**
 * Get visitor area traffic latest data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const queueManagementControllerGetRetailVisitorAreaTrafficLatestData = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<QueueManagementControllerGetRetailVisitorAreaTrafficLatestDataData, ThrowOnError>) => {
    return (options?.client ?? client).get<QueueManagementControllerGetRetailVisitorAreaTrafficLatestDataResponse, QueueManagementControllerGetRetailVisitorAreaTrafficLatestDataError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/visitor-area-traffic-latest/{widgetId}'
    });
};

/**
 * Get vehicle queue analytics data by category
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const queueManagementControllerGetVehicleQueueCategoryAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<QueueManagementControllerGetVehicleQueueCategoryAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<QueueManagementControllerGetVehicleQueueCategoryAnalyticsResponse, QueueManagementControllerGetVehicleQueueCategoryAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/vehicle-queue-category-analytics'
    });
};

/**
 * Get cumulative shopping counts and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const shoppingCartCountControllerGetShoppingCartCounts = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ShoppingCartCountControllerGetShoppingCartCountsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ShoppingCartCountControllerGetShoppingCartCountsResponse, ShoppingCartCountControllerGetShoppingCartCountsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/shopping-cart-count/{widgetId}'
    });
};

/**
 * Get number of shopping cart counts and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const shoppingCartCountControllerGetCurrentShoppingCartCount = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ShoppingCartCountControllerGetCurrentShoppingCartCountData, ThrowOnError>) => {
    return (options?.client ?? client).get<ShoppingCartCountControllerGetCurrentShoppingCartCountResponse, ShoppingCartCountControllerGetCurrentShoppingCartCountError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/current-shopping-cart-count/{widgetId}'
    });
};

/**
 * Get cumulative shopping cart analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const shoppingCartCountControllerGetCumulativeShoppingCartAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ShoppingCartCountControllerGetCumulativeShoppingCartAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<ShoppingCartCountControllerGetCumulativeShoppingCartAnalyticsResponse, ShoppingCartCountControllerGetCumulativeShoppingCartAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/cumulative-shopping-cart-analytics'
    });
};

/**
 * Get shopping cart in use analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const shoppingCartCountControllerGetShoppingCartInUseAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ShoppingCartCountControllerGetShoppingCartInUseAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<ShoppingCartCountControllerGetShoppingCartInUseAnalyticsResponse, ShoppingCartCountControllerGetShoppingCartInUseAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/shopping-cart-in-use-analytics'
    });
};

/**
 * Get cumulative shopping cart analytics data by category
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const shoppingCartCountControllerGetCumulativeShoppingCartCategoryAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ShoppingCartCountControllerGetCumulativeShoppingCartCategoryAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<ShoppingCartCountControllerGetCumulativeShoppingCartCategoryAnalyticsResponse, ShoppingCartCountControllerGetCumulativeShoppingCartCategoryAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/cumulative-shopping-cart-category-analytics'
    });
};

/**
 * Get shopping cart in use analytics data by category
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const shoppingCartCountControllerGetShoppingCartInUseCategoryAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ShoppingCartCountControllerGetShoppingCartInUseCategoryAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<ShoppingCartCountControllerGetShoppingCartInUseCategoryAnalyticsResponse, ShoppingCartCountControllerGetShoppingCartInUseCategoryAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/shopping-cart-in-use-category-analytics'
    });
};

/**
 * Get slip and fall counts and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const slipAndFallControllerGetSlipAndFallCounts = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<SlipAndFallControllerGetSlipAndFallCountsData, ThrowOnError>) => {
    return (options?.client ?? client).get<SlipAndFallControllerGetSlipAndFallCountsResponse, SlipAndFallControllerGetSlipAndFallCountsError, ThrowOnError>({
        ...options,
        url: '/v2/organizations/{orgId}/slip-and-fall/{widgetId}'
    });
};

/**
 * Get the total stopped vehicle counts and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const stoppedVehicleControllerGetStoppedVehicle = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<StoppedVehicleControllerGetStoppedVehicleData, ThrowOnError>) => {
    return (options?.client ?? client).get<StoppedVehicleControllerGetStoppedVehicleResponse, StoppedVehicleControllerGetStoppedVehicleError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/stopped-vehicle/{widgetId}'
    });
};

/**
 * Get stopped vehicle analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const stoppedVehicleControllerGetStoppedVehicleAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<StoppedVehicleControllerGetStoppedVehicleAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<StoppedVehicleControllerGetStoppedVehicleAnalyticsResponse, StoppedVehicleControllerGetStoppedVehicleAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/stopped-vehicle-analytics'
    });
};

/**
 * Get stopped vehicle category analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const stoppedVehicleControllerGetStoppedVehicleCategoryAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<StoppedVehicleControllerGetStoppedVehicleCategoryAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<StoppedVehicleControllerGetStoppedVehicleCategoryAnalyticsResponse, StoppedVehicleControllerGetStoppedVehicleCategoryAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/stopped-vehicle-category-analytics'
    });
};

/**
 * Get cumulative vehicle counts and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const vehicleCountControllerGetVehicleCounts = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<VehicleCountControllerGetVehicleCountsData, ThrowOnError>) => {
    return (options?.client ?? client).get<VehicleCountControllerGetVehicleCountsResponse, VehicleCountControllerGetVehicleCountsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/vehicle-count/{widgetId}'
    });
};

/**
 * Get cumulative vehicle count analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const vehicleCountControllerGetVehicleCountAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<VehicleCountControllerGetVehicleCountAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<VehicleCountControllerGetVehicleCountAnalyticsResponse, VehicleCountControllerGetVehicleCountAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/cumulative-vehicle-count-analytics'
    });
};

/**
 * Get vehicle in/out and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const vehicleCountControllerGetVehicleInOut = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<VehicleCountControllerGetVehicleInOutData, ThrowOnError>) => {
    return (options?.client ?? client).get<VehicleCountControllerGetVehicleInOutResponse, VehicleCountControllerGetVehicleInOutError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/vehicle-in-out/{widgetId}'
    });
};

/**
 * Get vehicle flow analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const vehicleCountControllerGetVehicleFlowAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<VehicleCountControllerGetVehicleFlowAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<VehicleCountControllerGetVehicleFlowAnalyticsResponse, VehicleCountControllerGetVehicleFlowAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/vehicle-flow-analytics'
    });
};

/**
 * Get vehicle occupancy and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const vehicleCountControllerGetStayingVehicle = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<VehicleCountControllerGetStayingVehicleData, ThrowOnError>) => {
    return (options?.client ?? client).get<VehicleCountControllerGetStayingVehicleResponse, VehicleCountControllerGetStayingVehicleError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/staying-vehicle/{widgetId}'
    });
};

/**
 * Get vehicle occupancy analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const vehicleCountControllerGetStayingVehicleAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<VehicleCountControllerGetStayingVehicleAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<VehicleCountControllerGetStayingVehicleAnalyticsResponse, VehicleCountControllerGetStayingVehicleAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/staying-vehicle-analytics'
    });
};

/**
 * Get cumulative vehicle analytics data by category
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const vehicleCountControllerGetVehicleCountCategoryAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<VehicleCountControllerGetVehicleCountCategoryAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<VehicleCountControllerGetVehicleCountCategoryAnalyticsResponse, VehicleCountControllerGetVehicleCountCategoryAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/cumulative-vehicle-count-category-analytics'
    });
};

/**
 * Get vehicle occupancy analytics data by category
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const vehicleCountControllerGetStayingVehicleCategoryAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<VehicleCountControllerGetStayingVehicleCategoryAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<VehicleCountControllerGetStayingVehicleCategoryAnalyticsResponse, VehicleCountControllerGetStayingVehicleCategoryAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/staying-vehicle-category-analytics'
    });
};

/**
 * Create report
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-report
 */
export const reportControllerCreateReport = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ReportControllerCreateReportData, ThrowOnError>) => {
    return (options?.client ?? client).post<ReportControllerCreateReportResponse, ReportControllerCreateReportError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/reports'
    });
};

/**
 * Get report list
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-report-menu
 */
export const reportControllerGetReports = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ReportControllerGetReportsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ReportControllerGetReportsResponse, ReportControllerGetReportsError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/reports'
    });
};

/**
 * Update report
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-report
 */
export const reportControllerUpdateReport = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ReportControllerUpdateReportData, ThrowOnError>) => {
    return (options?.client ?? client).put<ReportControllerUpdateReportResponse, ReportControllerUpdateReportError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/reports/{reportId}'
    });
};

/**
 * Delete report
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-report
 */
export const reportControllerDeleteReport = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ReportControllerDeleteReportData, ThrowOnError>) => {
    return (options?.client ?? client).delete<ReportControllerDeleteReportResponse, ReportControllerDeleteReportError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/reports/{reportId}'
    });
};

/**
 * Get report detail
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-report-menu
 */
export const reportControllerGetReportDetails = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ReportControllerGetReportDetailsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ReportControllerGetReportDetailsResponse, ReportControllerGetReportDetailsError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/reports/{reportId}'
    });
};

/**
 * Generates report pdf
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-report-menu
 */
export const reportControllerGenerateReportPdf = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ReportControllerGenerateReportPdfData, ThrowOnError>) => {
    return (options?.client ?? client).get<ReportControllerGenerateReportPdfResponse, ReportControllerGenerateReportPdfError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/reports/{reportId}/export'
    });
};

/**
 * Generate widget insight
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-report
 */
export const reportControllerGenerateWidgetInsight = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ReportControllerGenerateWidgetInsightData, ThrowOnError>) => {
    return (options?.client ?? client).post<ReportControllerGenerateWidgetInsightResponse, ReportControllerGenerateWidgetInsightError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/reports/{reportId}/generate-insight'
    });
};

/**
 * Send report pdf via mail
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-report
 */
export const reportControllerMailReportPdf = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ReportControllerMailReportPdfData, ThrowOnError>) => {
    return (options?.client ?? client).post<ReportControllerMailReportPdfResponse, ReportControllerMailReportPdfError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/reports/{reportId}/mail'
    });
};

/**
 * Share report
 *
 *
 * ### One of the permissions is required:
 *
 * * can-add-edit-delete-report
 */
export const reportControllerShareReport = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ReportControllerShareReportData, ThrowOnError>) => {
    return (options?.client ?? client).post<ReportControllerShareReportResponse, ReportControllerShareReportError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/reports/{reportId}/share'
    });
};

/**
 * Get slow traffic and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const slowTrafficControllerGetSlowTrafficCounts = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<SlowTrafficControllerGetSlowTrafficCountsData, ThrowOnError>) => {
    return (options?.client ?? client).get<SlowTrafficControllerGetSlowTrafficCountsResponse, SlowTrafficControllerGetSlowTrafficCountsError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/slow-traffic/{widgetId}'
    });
};

/**
 * Export widget data to csv
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const exportDataControllerExportDataToCsv = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ExportDataControllerExportDataToCsvData, ThrowOnError>) => {
    return (options?.client ?? client).get<ExportDataControllerExportDataToCsvResponse, ExportDataControllerExportDataToCsvError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/dashboards/{dashboardId}/widgets/{widgetId}/export'
    });
};

/**
 * Export analytics data to csv
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const exportDataControllerExportAnalyticsDataToCsv = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ExportDataControllerExportAnalyticsDataToCsvData, ThrowOnError>) => {
    return (options?.client ?? client).post<ExportDataControllerExportAnalyticsDataToCsvResponse, ExportDataControllerExportAnalyticsDataToCsvError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/analytics/export'
    });
};

/**
 * Get shopping cart loss and related chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const shoppingCartLossControllerGetShoppingCartLossCounts = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ShoppingCartLossControllerGetShoppingCartLossCountsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ShoppingCartLossControllerGetShoppingCartLossCountsResponse, ShoppingCartLossControllerGetShoppingCartLossCountsError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/shopping-cart-loss/{widgetId}'
    });
};

/**
 * Get fork lift speed data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const forkliftSpeedControllerGetForkliftSpeedCounts = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ForkliftSpeedControllerGetForkliftSpeedCountsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ForkliftSpeedControllerGetForkliftSpeedCountsResponse, ForkliftSpeedControllerGetForkliftSpeedCountsError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/forklift-speed/{widgetId}'
    });
};

/**
 * Get total people count, current people count and every device rule's in/out people count by mapId
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const mapMarkerCountControllerGetMapMarkerCounting = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<MapMarkerCountControllerGetMapMarkerCountingData, ThrowOnError>) => {
    return (options?.client ?? client).get<MapMarkerCountControllerGetMapMarkerCountingResponse, MapMarkerCountControllerGetMapMarkerCountingError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/map-marker-counting/{widgetId}'
    });
};

/**
 * Get statistsics count and chartData
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const eventStatisticsControllerGetEventStatistics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<EventStatisticsControllerGetEventStatisticsData, ThrowOnError>) => {
    return (options?.client ?? client).get<EventStatisticsControllerGetEventStatisticsResponse, EventStatisticsControllerGetEventStatisticsError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/event-statistics-count/{widgetId}'
    });
};

/**
 * Get event trend chart data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const eventStatisticsControllerGetEventTrendChart = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<EventStatisticsControllerGetEventTrendChartData, ThrowOnError>) => {
    return (options?.client ?? client).get<EventStatisticsControllerGetEventTrendChartResponse, EventStatisticsControllerGetEventTrendChartError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/event-trend-chart/{widgetId}'
    });
};

/**
 * Get slip and fall analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const eventStatisticsControllerGetSlipAndFallAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<EventStatisticsControllerGetSlipAndFallAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<EventStatisticsControllerGetSlipAndFallAnalyticsResponse, EventStatisticsControllerGetSlipAndFallAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/slip-and-fall-analytics'
    });
};

/**
 * Get slip and fall analytics data by category
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const eventStatisticsControllerGetSlipAndFallCategoryAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<EventStatisticsControllerGetSlipAndFallCategoryAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<EventStatisticsControllerGetSlipAndFallCategoryAnalyticsResponse, EventStatisticsControllerGetSlipAndFallCategoryAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/slip-and-fall-category-analytics'
    });
};

/**
 * Get slow traffic analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const eventStatisticsControllerGetSlowTrafficAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<EventStatisticsControllerGetSlowTrafficAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<EventStatisticsControllerGetSlowTrafficAnalyticsResponse, EventStatisticsControllerGetSlowTrafficAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/slow-traffic-analytics'
    });
};

/**
 * Get slow traffic category analytics data
 *
 *
 * ### One of the permissions is required:
 *
 * * can-search-event
 *
 * * can-play-playback-in-event
 */
export const eventStatisticsControllerGetSlowTrafficCategoryAnalytics = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<EventStatisticsControllerGetSlowTrafficCategoryAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? client).post<EventStatisticsControllerGetSlowTrafficCategoryAnalyticsResponse, EventStatisticsControllerGetSlowTrafficCategoryAnalyticsError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/slow-traffic-category-analytics'
    });
};

/**
 * Send a prompt to the AI model
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 *
 * * can-play-playback-in-event
 */
export const aiInsightControllerSendPrompt = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<AiInsightControllerSendPromptData, ThrowOnError>) => {
    return (options?.client ?? client).post<AiInsightControllerSendPromptResponse, AiInsightControllerSendPromptError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/analytics/{insightType}/chat'
    });
};

/**
 * claim device
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-device-management-menu
 */
export const deviceControllerClaimDevice = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DeviceControllerClaimDeviceData, ThrowOnError>) => {
    return (options?.client ?? client).post<DeviceControllerClaimDeviceResponse, DeviceControllerClaimDeviceError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/devices'
    });
};

/**
 * get for device added in the portal
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const deviceControllerGetPortalDevices = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DeviceControllerGetPortalDevicesData, ThrowOnError>) => {
    return (options?.client ?? client).get<DeviceControllerGetPortalDevicesResponse, DeviceControllerGetPortalDevicesError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/devices'
    });
};

/**
 * update claim device
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-device-management-menu
 */
export const deviceControllerUpdateClaimDevice = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DeviceControllerUpdateClaimDeviceData, ThrowOnError>) => {
    return (options?.client ?? client).put<DeviceControllerUpdateClaimDeviceResponse, DeviceControllerUpdateClaimDeviceError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/devices'
    });
};

/**
 * update all claim device
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-device-management-menu
 */
export const deviceControllerUpdateAllClaimDevice = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DeviceControllerUpdateAllClaimDeviceData, ThrowOnError>) => {
    return (options?.client ?? client).put<DeviceControllerUpdateAllClaimDeviceResponse, DeviceControllerUpdateAllClaimDeviceError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/devices/all'
    });
};

/**
 * @deprecated
 * unclaim device
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-device-management-menu
 */
export const deviceControllerUnclaimDevice = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DeviceControllerUnclaimDeviceData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeviceControllerUnclaimDeviceResponse, DeviceControllerUnclaimDeviceError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/devices/{deviceId}'
    });
};

/**
 * unclaim bulk devices
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-device-management-menu
 */
export const deviceControllerUnclaimBulkDevices = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DeviceControllerUnclaimBulkDevicesData, ThrowOnError>) => {
    return (options?.client ?? client).post<DeviceControllerUnclaimBulkDevicesResponse, DeviceControllerUnclaimBulkDevicesError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/devices/unclaim'
    });
};

/**
 * Get configurations of devices
 * Retrieve a list of device configurations. If multiple ruleTypes are selected, the data is filtered using OR logic, not AND.
 *
 * ### One of the permissions is required:
 *
 * * can-view-device-management-menu
 *
 * * can-setting-widget
 *
 * * can-search-event
 *
 * * can-add-delete-show-hide-widget
 *
 * * can-monitoring-dashboard
 */
export const deviceControllerGetDeviceConfigList = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DeviceControllerGetDeviceConfigListData, ThrowOnError>) => {
    return (options?.client ?? client).get<DeviceControllerGetDeviceConfigListResponse, DeviceControllerGetDeviceConfigListError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/devices/configs'
    });
};

/**
 * Get configuration of device
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-device-management-menu
 *
 * * can-setting-widget
 *
 * * can-search-event
 *
 * * can-add-delete-show-hide-widget
 *
 * * can-monitoring-dashboard
 */
export const deviceControllerGetDeviceConfig = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DeviceControllerGetDeviceConfigData, ThrowOnError>) => {
    return (options?.client ?? client).get<DeviceControllerGetDeviceConfigResponse, DeviceControllerGetDeviceConfigError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/devices/{gatewayId}/config'
    });
};

/**
 * Get snapshot of device
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-device-management-menu
 *
 * * can-setting-widget
 *
 * * can-search-event
 *
 * * can-add-delete-show-hide-widget
 *
 * * can-monitoring-dashboard
 */
export const deviceControllerGetDeviceSnapshot = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DeviceControllerGetDeviceSnapshotData, ThrowOnError>) => {
    return (options?.client ?? client).get<DeviceControllerGetDeviceSnapshotResponse, DeviceControllerGetDeviceSnapshotError, ThrowOnError>({
        ...options,
        url: '/v3/organizations/{orgId}/devices/{gatewayId}/snapshot'
    });
};

/**
 * Get license list
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const licenseControllerGetLicenses = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<LicenseControllerGetLicensesData, ThrowOnError>) => {
    return (options?.client ?? client).get<LicenseControllerGetLicensesResponse, LicenseControllerGetLicensesError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/licenses'
    });
};

/**
 * Get OnCloud license status
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const licenseControllerOnCloudLicensebyDeviceId = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<LicenseControllerOnCloudLicensebyDeviceIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<LicenseControllerOnCloudLicensebyDeviceIdResponse, LicenseControllerOnCloudLicensebyDeviceIdError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/licenses/{deviceId}/device'
    });
};

/**
 * Attach licenses to devices
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-device-management-menu
 */
export const licenseControllerAttachLicenses = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<LicenseControllerAttachLicensesData, ThrowOnError>) => {
    return (options?.client ?? client).post<LicenseControllerAttachLicensesResponse, LicenseControllerAttachLicensesError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/licenses/attach'
    });
};

/**
 * Detach licenses from devices
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-device-management-menu
 */
export const licenseControllerDetachLicenses = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<LicenseControllerDetachLicensesData, ThrowOnError>) => {
    return (options?.client ?? client).delete<LicenseControllerDetachLicensesResponse, LicenseControllerDetachLicensesError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/licenses/detach'
    });
};

/**
 * Send command to device
 */
export const sdcsControllerSendCommand = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<SdcsControllerSendCommandData, ThrowOnError>) => {
    return (options?.client ?? client).get<SdcsControllerSendCommandResponse, SdcsControllerSendCommandError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/devices/{deviceId}/sdcs'
    });
};

export const sdcsControllerCheckWiseAi = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<SdcsControllerCheckWiseAiData, ThrowOnError>) => {
    return (options?.client ?? client).get<SdcsControllerCheckWiseAiResponse, SdcsControllerCheckWiseAiError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/devices/{deviceId}/check-wiseai'
    });
};

/**
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-device-management-menu
 */
export const wavesyncControllerLink = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WavesyncControllerLinkData, ThrowOnError>) => {
    return (options?.client ?? client).get<WavesyncControllerLinkResponse, WavesyncControllerLinkError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/wavesync/link'
    });
};

/**
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-device-management-menu
 */
export const wavesyncControllerUnlink = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WavesyncControllerUnlinkData, ThrowOnError>) => {
    return (options?.client ?? client).get<WavesyncControllerUnlinkResponse, WavesyncControllerUnlinkError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/wavesync/unlink'
    });
};

/**
 * Get wavesync link status
 *
 *
 * ### One of the permissions is required:
 *
 * * can-monitoring-dashboard
 */
export const wavesyncControllerGetLinkStatus = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WavesyncControllerGetLinkStatusData, ThrowOnError>) => {
    return (options?.client ?? client).get<WavesyncControllerGetLinkStatusResponse, WavesyncControllerGetLinkStatusError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/wavesync/link-status'
    });
};

/**
 * Get wavesync devices
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-device-management-menu
 *
 * * can-search-event
 *
 * * can-setting-widget
 */
export const wavesyncControllerGetDevices = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WavesyncControllerGetDevicesData, ThrowOnError>) => {
    return (options?.client ?? client).get<WavesyncControllerGetDevicesResponse, WavesyncControllerGetDevicesError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/wavesync/systems/devices'
    });
};

/**
 *
 *
 * ### One of the permissions is required:
 *
 * * can-view-device-management-menu
 *
 * * can-play-live-playback-in-widget
 *
 * * can-play-playback-in-event
 */
export const wavesyncControllerGetHls = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<WavesyncControllerGetHlsData, ThrowOnError>) => {
    return (options?.client ?? client).get<WavesyncControllerGetHlsResponse, WavesyncControllerGetHlsError, ThrowOnError>({
        ...options,
        url: '/v1/organizations/{orgId}/wavesync/systems/{systemId}/devices/{deviceId}/hls'
    });
};